'use strict';

(function (global) {
  /**
   * Функции отвечающие за работу с задачами и заданиями.
   * @namespace Core.customWorks
   * @since 5.5.0.2201
   */
  global.customWorks = {};
})(window.Core);

(function (global) {

  /**
   * Отобразить диалог назначения прав доступа на вложения.
   *
   * @global
   * @function showAccessRightsDialog
   * @param {string} maxRights Максимально доступные права для назначения.
   * @param {object} buttonHandlers Ассоциативный массив обработчиков событий нажатия на кнопку.
   * @private
   */
  global.showAccessRightsDialog = (maxRights, buttonHandlers) => {
    // Список возможных вариантов прав доступа и соответствующих
    // им кнопок в диалоге
    const accessRightButtons = {
      View: {
        id: 'view_right_btn',
        caption: L('VIEWING'),
        onClick: buttonHandlers.View,
      },
      Change: {
        id: 'modify_right_btn',
        caption: L('MODIFY'),
        onClick: buttonHandlers.Change,
      },
      Full: {
        id: 'full_right_btn',
        caption: L('FULL'),
        onClick: buttonHandlers.Full,
      },
    };

    let accessRightsDialog = new WA.CMP.dialogs.MessageBox();
    for (let accessRightsKey in accessRightButtons) {
      const buttonModel = accessRightButtons[accessRightsKey];
      accessRightsDialog.addButton(buttonModel.id, buttonModel.caption, buttonModel.onClick);
      if (accessRightsKey === maxRights) {
        break;
      }
    }
    accessRightsDialog
      .addButton('ignore_button', L('IGNORE'), buttonHandlers.Ignore)
      ._setDefaultButton('view_right_btn');

    // Установить доступность кнопок
    accessRightsDialog.isShowCancelButton = true;
    accessRightsDialog.isShowOkButton = false;

    accessRightsDialog.showQuestion(
      L('ASSING_TASK_ATTACHMENTS_RIGHTS_DLG_CAPTION'),
      L('ASSING_TASK_ATTACHMENTS_RIGHTS_DLG_MSG'),
      L('ACCESS_RIGHTS'),
    );
  }

  /**
   * Установить доступность кнопок на ленте для задач и заданий.
   * @since 5.5.2201
   */
  global.bindButtonsEnabling = (textAreaSelector) => {
    WA.ready(() => {
      const buttonNames = [ 'Save' ];
      // Флаг, указывающий необходимость осуществления блокировки кнопок не ленте на основе режима доступности
      let isControlChangedBefore = false;

      const jTextArea = $(textAreaSelector);
      const initialTextAreaValue = jTextArea.val();
      jTextArea.bind('keyup', () => {
        if (jTextArea.val() !== initialTextAreaValue) {
          Core.cards.enableButtonsOnFormChange(buttonNames);
          if (!isControlChangedBefore) {
            Core.cards.setButtonsEnablingOnEnabledMode();
            isControlChangedBefore = true;
          }
        }
      });
      // Установить изменение доступности при изменении списка вложений.
      const jAttachments = $('.ListRequisite');
      jAttachments.change(() => {
        Core.cards.enableButtonsOnFormChange(buttonNames);
        if (!isControlChangedBefore) {
          Core.cards.setButtonsEnablingOnEnabledMode();
          isControlChangedBefore = true;
        }
      });
      // Установить изменение состояний на основе выделения списка вложений
      jAttachments.on('itemChecked', () => {
        const buttons = WA.CR.toolBar.buttons.getButtonsEnabledOnAttachmentSelection();
        const selectedItems = WA.CR.objectList.getSelectedItems();
        if (selectedItems.length) {
          buttons.forEach((button) => {
            // В зависимости от состояния ЗЗУ
            switch (WA.CR.State) {
              case WORK_STATE.RUNNING:
              case WORK_STATE.CONTROLLED:
              case WORK_STATE.CONTINUED:
                if (button.getIsEnabledOnRunning()) {
                  button.enable();
                }
                break;
              case WORK_STATE.DONE:
                if (button.getIsEnabledOnDone()) {
                  button.enable();
                }
                break;
              case WORK_STATE.ABORTED:
                if (button.getIsEnabledOnAborted()) {
                  button.enable();
                }
                break;
            }
          });
        } else {
          buttons.forEach((button) => {
            button.disable();
          });
        }
      });
    });
  };

})(window.Core.customWorks);
